import { FC } from 'react';
import { toast } from 'react-toastify';
import Modal from '@new/common/ui/Modal/Modal';
import { Button } from '@new/common/ui';
import { useDeleteCourseInstructorMutation } from '@teachur/http-client';
import type { User as UserType } from '@teachur/http-client';

interface DeleteInstructorModalProps {
  isOpen: boolean;
  onClose: () => void;
  courseId: number;
  instructor: UserType;
  onSuccess: () => void;
}

export const DeleteInstructorModal: FC<DeleteInstructorModalProps> = ({
  isOpen,
  onClose,
  courseId,
  instructor,
  onSuccess,
}) => {
  const deleteInstructorMutation = useDeleteCourseInstructorMutation({
    onSuccess: () => {
      toast.success('Instructor removed successfully!');
      onSuccess();
      onClose();
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to remove instructor');
    },
  });

  const handleDelete = () => {
    deleteInstructorMutation.mutate({ courseId, userId: instructor.id });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Remove Instructor" className="w-100 h-auto">
      <div className="flex flex-col gap-6">
        <p className="[font-size:var(--fs-p2)]! text-(--neutral-black-NB1000)! m-0!">
          Are you sure you want to remove{' '}
          <span className="font-bold">
            {instructor.firstName} {instructor.lastName}
          </span>{' '}
          from this course?
        </p>

        <div className="flex items-center gap-3 justify-end">
          <Button variant="outline" onClick={onClose} disabled={deleteInstructorMutation.isPending}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleDelete}
            disabled={deleteInstructorMutation.isPending}
            className="bg-(--danger-D700) hover:bg-(--danger-D700) text-white"
          >
            {deleteInstructorMutation.isPending ? 'Removing...' : 'Remove'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
